import { $el } from 'src/scripts/utils/utils'
import { BaseComponent } from '../../components/base-component'
import { PopupPromo } from './popup-promo'
import { isMobile } from 'src/scripts/utils/check-media'
import { gradientOpacity } from './utils'

const TARGET_POPUP_ATTRIBUTE = 'data-target-popup-id'
const CAN_BE_CLOSED_ATTRIBUTE = 'data-can-be-closed-on'
const CLOSE_BTN_SELECTOR = '[data-popup-teaser-close]'
const ANIMATION_OPTIONS: KeyframeAnimationOptions = {
  duration: 750,
  easing: 'ease-in-out',
  fill: 'forwards',
}

export class PopupTeaser extends BaseComponent {
  targetPopup: PopupPromo
  canBeClosedOn: string
  removePermanently: boolean
  withGradient: boolean

  mountComponent(): void {
    this.removePermanently = false
    this.canBeClosedOn = this.getAttribute(CAN_BE_CLOSED_ATTRIBUTE)

    this.targetPopup = $el(
      `[data-block-id="${this.getAttribute(TARGET_POPUP_ATTRIBUTE)}"]`,
      this.parentElement,
    )

    this.addListener(this, 'click', this.handleTeaserClick)
    this.targetPopup.on('popupHidden', this.showTeaser)
    this.targetPopup.on('popupShown', this.hideTeaser)

    this.setCloseBtnGradient()

    if (this.isEditor) {
      this.editor.on('BLOCK_SELECT', this.handleBlockSelect)
      this.editor.on('BLOCK_DESELECT', this.handleBlockDeselect)
    }
  }

  unmountComponent(): void {
    this.removeListener(this, 'click', this.handleTeaserClick)
    this.targetPopup.off('popupHidden', this.showTeaser)
    this.targetPopup.off('popupShown', this.hideTeaser)

    if (this.isEditor) {
      this.editor.off('BLOCK_SELECT', this.handleBlockSelect)
      this.editor.off('BLOCK_DESELECT', this.handleBlockDeselect)
    }
  }

  showTeaser = async () => {
    await this.animate({ [this.getTeaserPosition()]: '0' }, ANIMATION_OPTIONS)
      .finished
  }

  hideTeaser = async () => {
    await this.animate(
      { [this.getTeaserPosition()]: '-50%' },
      ANIMATION_OPTIONS,
    ).finished

    if (this.removePermanently) {
      this.remove()
    }
  }

  getTeaserPosition = () => {
    const { left, right } = getComputedStyle(this)
    const isLeft = parseInt(left) < 1
    const isRight = parseInt(right) < 1

    return isLeft ? 'left' : isRight ? 'right' : 'bottom'
  }

  handleTeaserClick = ({ target }) => {
    if (target.closest(CLOSE_BTN_SELECTOR)) {
      this.removePermanently = true
      this.hideTeaser()
    } else {
      this.showPopup()
    }
  }

  showPopup = () => {
    this.targetPopup.show()

    const isNowMobile = isMobile()
    this.removePermanently =
      (isNowMobile && !this.canBeClosedOn?.includes('mobile')) ||
      (!isNowMobile && !this.canBeClosedOn?.includes('desktop'))

    this.hideTeaser()
  }

  setCloseBtnGradient = () => {
    if (this.hasAttribute('data-gradient') && !this.withGradient) {
      const btn = $el(CLOSE_BTN_SELECTOR, this)

      btn?.setAttribute(
        'style',
        `--gsc-teaser-close-background-color: ${gradientOpacity(
          this.dataset.gradient,
          this.dataset.opacity,
        )}`,
      )

      this.withGradient = true
    }
  }

  handleBlockSelect = ({ detail: { blockId } }): void => {
    if (this.dataset.targetPopupId === blockId) {
      this.style.zIndex = '10001'
      this.showTeaser()
    }
  }

  handleBlockDeselect = ({ detail: { blockId } }): void => {
    if (this.dataset.targetPopupId === blockId) {
      this.hideTeaser()
      this.removeAttribute('style')
    }
  }
}
